import {GenericService, ResultType} from '@/shared/xhttp';
import {Organisation} from '@/models';

export class OrganisationService extends GenericService<Organisation> {
}